class Concurrency {
    partialServiceUrl = '';
    encryptedLock = '';
    lockId = '';
    playerId = '';
    sequenceToken = '';
    updateIntervalMs = -1;
    isEnabled = false;

    constructor() {
        Object.seal(this);
    }

    get serviceUrl() {
        return `${this.partialServiceUrl}/web/Concurrency/update`;
    }
}

export default Concurrency;
